import { CpReceiptDetailInterface } from '../../../../interfaces/dto/receipt/receipt-detail/cp-receipt-detail-interface';

export class CpReceiptDetailModel implements CpReceiptDetailInterface {
  BillingDate: string = '';
  CancelDate: string = '';
  CommercialPremium: number | undefined = -1;
  ContractNumber: string = '';
  EmissionDate: string = '';
  EndDate: string = '';
  EntityMB: string = '';
  PaymentDate: string = '';
  PaymentMethod: string = '';
  ProductName: string = '';
  ReceiptNumber: string = '';
  ReferenceMB: string = '';
  SendBillingDate: string = '';
  StartDate: string = '';
  State: string = '';
  StateTag: string = '';
  TaxAmount: number | undefined = -1;
  TotalAmount: number | undefined = -1;
  TotalPremium: string = '';
}
